<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Filter einstellen"}}</h4>
</div>
<div class="modal-body">
	<div class="deviceFilter"></div>
</div>
<div class="modal-footer">
    <button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
    <button class="btn btn-primary" id="js-success">{{TR "Speichern"}}</button>
</div>
